var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ReadonlyCollection_list;
import { List } from "linq.ts";
export class ReadonlyCollection {
    constructor(elements) {
        _ReadonlyCollection_list.set(this, void 0);
        __classPrivateFieldSet(this, _ReadonlyCollection_list, new List(elements), "f");
    }
    aggregate(accumulator, initialValue) {
        return new ReadonlyCollection(__classPrivateFieldGet(this, _ReadonlyCollection_list, "f").Aggregate(accumulator));
    }
    all(predicate) {
        return __classPrivateFieldGet(this, _ReadonlyCollection_list, "f").All(predicate);
    }
    any(predicate) {
        return __classPrivateFieldGet(this, _ReadonlyCollection_list, "f").Any(predicate);
    }
    average(transform) {
        return __classPrivateFieldGet(this, _ReadonlyCollection_list, "f").Average(transform);
    }
    cast() {
        return new ReadonlyCollection(__classPrivateFieldGet(this, _ReadonlyCollection_list, "f").Cast().ToArray());
    }
    concat(list) {
        const _list = new List(list.toArray());
        return new ReadonlyCollection(__classPrivateFieldGet(this, _ReadonlyCollection_list, "f").Concat(_list).ToArray());
    }
    contains(element) {
        return __classPrivateFieldGet(this, _ReadonlyCollection_list, "f").Contains(element);
    }
    count(predicate) {
        return __classPrivateFieldGet(this, _ReadonlyCollection_list, "f").Count(predicate);
    }
    defaultIfEmpty(defaultValue) {
        return new ReadonlyCollection(__classPrivateFieldGet(this, _ReadonlyCollection_list, "f").DefaultIfEmpty(defaultValue).ToArray());
    }
    distinct() {
        return new ReadonlyCollection(__classPrivateFieldGet(this, _ReadonlyCollection_list, "f").Distinct().ToArray());
    }
    distinctBy(keySelector) {
        return new ReadonlyCollection(__classPrivateFieldGet(this, _ReadonlyCollection_list, "f").DistinctBy(keySelector).ToArray());
    }
    elementAt(index) {
        return __classPrivateFieldGet(this, _ReadonlyCollection_list, "f").ElementAt(index);
    }
    elementAtOrDefault(index) {
        return __classPrivateFieldGet(this, _ReadonlyCollection_list, "f").ElementAtOrDefault(index);
    }
    except(source) {
        const _source = new List(source.toArray());
        return new ReadonlyCollection(__classPrivateFieldGet(this, _ReadonlyCollection_list, "f").Except(_source).ToArray());
    }
    first(predicate) {
        return __classPrivateFieldGet(this, _ReadonlyCollection_list, "f").First(predicate);
    }
    firstOrDefault(predicate) {
        return __classPrivateFieldGet(this, _ReadonlyCollection_list, "f").FirstOrDefault(predicate);
    }
    forEach(action) {
        __classPrivateFieldGet(this, _ReadonlyCollection_list, "f").ForEach(action);
    }
    groupBy(grouper, mapper) {
        __classPrivateFieldGet(this, _ReadonlyCollection_list, "f").GroupBy(grouper, mapper);
    }
    groupJoin(list, key1, key2, result) {
        const _list = new List(list.toArray());
        return new ReadonlyCollection(__classPrivateFieldGet(this, _ReadonlyCollection_list, "f").GroupJoin(_list, key1, key2, result).ToArray());
    }
    indexOf(element) {
        return __classPrivateFieldGet(this, _ReadonlyCollection_list, "f").IndexOf(element);
    }
    intersect(source) {
        const _source = new List(source.toArray());
        return new ReadonlyCollection(__classPrivateFieldGet(this, _ReadonlyCollection_list, "f").Intersect(_source).ToArray());
    }
    join(list, key1, key2, result) {
        const _list = new List(list.toArray());
        return new ReadonlyCollection(__classPrivateFieldGet(this, _ReadonlyCollection_list, "f").Join(_list, key1, key2, result).ToArray());
    }
    last(predicate) {
        return __classPrivateFieldGet(this, _ReadonlyCollection_list, "f").Last(predicate);
    }
    lastOrDefault(predicate) {
        return __classPrivateFieldGet(this, _ReadonlyCollection_list, "f").LastOrDefault(predicate);
    }
    max() {
        return __classPrivateFieldGet(this, _ReadonlyCollection_list, "f").Max();
    }
    min() {
        return __classPrivateFieldGet(this, _ReadonlyCollection_list, "f").Min();
    }
    orderBy(keySelector) {
        return new ReadonlyCollection(__classPrivateFieldGet(this, _ReadonlyCollection_list, "f").OrderBy(keySelector).ToArray());
    }
    orderByDescending(keySelector) {
        return new ReadonlyCollection(__classPrivateFieldGet(this, _ReadonlyCollection_list, "f").OrderByDescending(keySelector).ToArray());
    }
    thenBy(keySelector) {
        return new ReadonlyCollection(__classPrivateFieldGet(this, _ReadonlyCollection_list, "f").ThenBy(keySelector).ToArray());
    }
    thenByDescending(keySelector) {
        return new ReadonlyCollection(__classPrivateFieldGet(this, _ReadonlyCollection_list, "f").ThenByDescending(keySelector).ToArray());
    }
    reverse() {
        return new ReadonlyCollection(__classPrivateFieldGet(this, _ReadonlyCollection_list, "f").Reverse().ToArray());
    }
    select(selector) {
        return new ReadonlyCollection(__classPrivateFieldGet(this, _ReadonlyCollection_list, "f").Select(selector).ToArray());
    }
    selectMany(selector) {
        const result = [];
        __classPrivateFieldGet(this, _ReadonlyCollection_list, "f").ForEach(x => result.push(...selector(x).toArray()));
        return new ReadonlyCollection(result);
    }
    sequenceEqual(list) {
        const _list = new List(list.toArray());
        return __classPrivateFieldGet(this, _ReadonlyCollection_list, "f").SequenceEqual(_list);
    }
    single(predicate) {
        return __classPrivateFieldGet(this, _ReadonlyCollection_list, "f").Single(predicate);
    }
    singleOrDefault(predicate) {
        return __classPrivateFieldGet(this, _ReadonlyCollection_list, "f").SingleOrDefault(predicate);
    }
    skip(amount) {
        return new ReadonlyCollection(__classPrivateFieldGet(this, _ReadonlyCollection_list, "f").Skip(amount).ToArray());
    }
    skipWhile(predicate) {
        return new ReadonlyCollection(__classPrivateFieldGet(this, _ReadonlyCollection_list, "f").SkipWhile(predicate).ToArray());
    }
    sum(transform) {
        return __classPrivateFieldGet(this, _ReadonlyCollection_list, "f").Sum(transform);
    }
    take(amount) {
        return new ReadonlyCollection(__classPrivateFieldGet(this, _ReadonlyCollection_list, "f").Take(amount).ToArray());
    }
    takeWhile(predicate) {
        return new ReadonlyCollection(__classPrivateFieldGet(this, _ReadonlyCollection_list, "f").TakeWhile(predicate).ToArray());
    }
    toArray() {
        return __classPrivateFieldGet(this, _ReadonlyCollection_list, "f").ToArray();
    }
    toDictionary(key, value) {
        return __classPrivateFieldGet(this, _ReadonlyCollection_list, "f").ToDictionary(key, value);
    }
    toLookup(keySelector, elementSelector) {
        return __classPrivateFieldGet(this, _ReadonlyCollection_list, "f").ToLookup(keySelector, elementSelector);
    }
    union(list) {
        const _list = new List(list.toArray());
        return new ReadonlyCollection(__classPrivateFieldGet(this, _ReadonlyCollection_list, "f").Union(_list).ToArray());
    }
    where(predicate) {
        return new ReadonlyCollection(__classPrivateFieldGet(this, _ReadonlyCollection_list, "f").Where(predicate).ToArray());
    }
}
_ReadonlyCollection_list = new WeakMap();
